<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div class="chat-bot-container">
    <deep-chat
      ref="chatBot"
      style="height: 100%; border-radius: 10px; border-color: #e4e4e4; background: #b4c4e3"
      :textInput="textInput"
      :loadingStep="{stepName: InitialStep}"
      :connect="{
        url: connectUrl,
        method: 'POST',
        credentials: 'include'
      }"
      
      :requestInterceptor="requestInterceptor"
      :responseInterceptor="responseInterceptor"
      demo="true"
    />
  </div>
</template>

<script>
import {
  RAG_SUBMIT_QUERY_ENDPOINT,
  RAG_ANSWER_ENDPOINT,
  BASE_URL
} from "../../assets/constants/api_endpoints.js";
import { isValidUrl } from "@/utils/utils.js"
import { REFERENCE_LINKS_HEADER } from "@/assets/constants/constants.js"

import { getWithAuthentication } from "@/services/api";
import {  DeepChat } from '../../external-components/deepChat.bundle.js'

export default {
  name: "ChatBotComponent",
  props: {
    subject:{
      type: Object,
      default: null
    }
  },
  data(){
    return {
      connectUrl: BASE_URL + RAG_SUBMIT_QUERY_ENDPOINT,
      currentPrompt: "",
      headers: {
        "Content-Type": "application/json",

      },
      InitialStep: "Initializing"
    };
  },
  methods: {
    async getPromptAnswer(id) { 
      const url = `${RAG_ANSWER_ENDPOINT}/${id}`
      const response = await getWithAuthentication(BASE_URL, url);
      return response
    },
    formatReferences(refs){
      const unique_refs = [...new Set(refs)]
      let files = []
      let urls = []

      for (let ref of unique_refs) {
        if (isValidUrl(ref)){
          urls.push(ref)
        } else {
          files.push(ref)
        }
      }
      files = files.map(doc => { return {"name": doc}});
      urls = urls.map(url => { return `<a href="${url}"> ${url} </a>`}).join(" ");
      urls = `${REFERENCE_LINKS_HEADER} ${urls}`
      return [files, urls]
    },
    requestInterceptor(details) {
      details.body = {
        prompt: details.body.messages[0].text,
        subject_id: this.subject.id.toString()
      }
      return details
    },
    async responseInterceptor(details) {
      let is_complete = false
      let answer = null
      let max_nb_attempts = 15
      let nb_attempts = 0
      while (!is_complete && nb_attempts < max_nb_attempts) {
        await new Promise(r => setTimeout(r, 5000));
        answer = await this.getPromptAnswer(details.id)
        is_complete = answer.data.is_complete
        let step = answer.data.progress_details? answer.data.progress_details : this.InitialStep
        this.$refs.chatBot.updateLoadingStep({stepName: step})
        nb_attempts += 1
      }

      if (!is_complete) {
        return {
          error: "Coundn't fetch a response. Please try again."
        }
      }

      const formattedAnswer = answer.data.answer
      let formattedReferences = this.formatReferences(answer.data.source_documents)
      this.$refs.chatBot.updateLoadingStep({stepName: this.InitialStep});
      return {
          text: formattedAnswer,
          files: formattedReferences[0],
          html: formattedReferences[1]
      }

      },
  }
}

</script>

<style>
.chat-bot-container {
    color: white;
    float: right;
    position: fixed;
    z-index: 1;
    top: 0;
    right: 0;
    bottom: 0;
    padding: 0.5em;
    display: flex;
    flex-direction: column;
    margin-top: 200px;
}

</style>